












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  PageDayPlan,
  PlanStatus,
  DayPlanOutline,
  PlanOutline,
} from '@/model/plan/dayPlan'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import { saveMyLearn } from '@/api/course/course'
import { State, Action, namespace } from 'vuex-class'
import { Course, MyLearn, Child } from '@/model/course/course'

interface PageOutline {
  courseId: string
  outlineId: string
  outlineIndex: number
  courseName: string
  outlineName: string
}

const ModuleUser = namespace('app-ice/user')

@Component
export default class TaskItem extends Vue {
  // @Prop({ type: Boolean, default: false })
  // current!: boolean

  @Prop({ type: Object, default: null })
  dayPlan!: PageDayPlan

  PlanStatus: any = PlanStatus
  num2Chinese: Function = num2Chinese
  audio: any = ''

  toLearn(pageOutline?: PageOutline) {
    // 理论上不会走这个 if
    // 因为这里是历史任务（解锁过的任务）
    if (!this.dayPlan.actived) {
      this.$message.warning('快去找班主任解锁任务吧～')
      return
    }
    // TODO 去学习
    this.saveMyLearn(pageOutline)
  }

  @ModuleUser.State((state) => state.myLearn)
  myLearn!: MyLearn
  @ModuleUser.Action('getMyLearn')
  getMyLearn!: Function
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function
  private async saveMyLearn(pageOutline?: PageOutline) {
    if (!pageOutline) {
      return
    }

    let outlineUrl = `${pageOutline.outlineIndex}/0/0`
    if (this.myLearn) {
      const course = this.myLearn.courses.find(
        (c: Child) => c.id === pageOutline.courseId
      )
      if (course) {
        outlineUrl = course.myCourse.learnUrl || outlineUrl
      }
    }

    await saveMyLearn([pageOutline.courseId])
    let learnUrl = `https://ham.youkeda.com/course/${
      pageOutline.courseId
    }/${outlineUrl}`
    window.open(learnUrl)
    await this.getMyLearn()
    this.handleMyLearn()
  }

  playResource() {
    if (!this.dayPlan.actived) {
      return
    }
    if (this.dayPlan.url) {
      if (this.isVideo(this.dayPlan.url)) {
        window.open(this.dayPlan.url)
      } else {
        if (!this.audio) {
          this.audio = document.createElement('audio') //生成一个audio元素
          this.$emit('updateAudio', this.audio)
        }

        if (this.audio.src === this.dayPlan.url) {
          this.audio.paused ? this.audio.play() : this.audio.pause()
        } else {
          this.audio.src = this.dayPlan.url
          this.audio.play()
        }
      }
    }
  }

  stopPlayAudioResource() {
    this.audio && this.audio.pause()
  }

  get dateStr() {
    if (this.dayPlan && this.dayPlan.planDay) {
      const month = new Date(this.dayPlan.planDay).getMonth() + 1
      const date = new Date(this.dayPlan.planDay).getDate()
      return `${month}月${date}号`
    }
    return ''
  }

  get dayPlanOutline() {
    // PageOutline
    const outlines: Array<PageOutline> = []
    if (this.dayPlan && this.dayPlan.dayPlanOutlines) {
      this.dayPlan.dayPlanOutlines.forEach((item: DayPlanOutline) => {
        // const item: DayPlanOutline = this.myDayPlan.dayPlan.dayPlanOutline
        const courseId = item.courseId
        const courseName = item.name
        item.planOutlines.forEach((o: PlanOutline) => {
          const outline: PageOutline = {
            courseId,
            courseName,
            outlineId: o.outlineId,
            outlineName: o.name,
            outlineIndex: o.index,
          }
          outlines.push(outline)
        })
      })
    }
    return outlines
  }

  isVideo(url: string) {
    return /(FLV)|(AVI)|(MOV)|(MP4)|(WMV)/i.test(url)
  }

  private beforeDestroy() {
    this.stopPlayAudioResource()
  }
}
